<template>
  <div>
    <main-layout>
      <div class="set-invoice" v-if="loaded">
        <el-form
          :model="codeForm"
          :validate-on-rule-change="false"
          ref="codeFormRef"
          label-position="right"
          label-width="180px"
          size="small"
        >
          <div class="pay-info-title">
            <span>开票金额</span>
          </div>
          <el-form-item label="交易日期" prop="tradeTimeRangeTmp" :rules="[Validator.required()]">
            <el-date-picker
              v-model="codeForm.tradeTimeRangeTmp"
              type="daterange"
              range-separator="~"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions"
              @change="onTradeTimeChange"
              :clearable="false"
            >
            </el-date-picker>
          </el-form-item>
          <div class="pay-money-info" v-if="codeForm.fee !== undefined">
            中付手续费金额
            <span class="money">¥{{ codeForm.fee }}</span>
            <!-- <span class="error-tips" v-show="codeForm.fee < 100 && codeForm.invoiceType === 2"
              >不足100元不可开票</span
            > -->
            <p class="tips">
              <i class="el-icon-warning"></i>
              金额以最终通道开出的发票金额为准，随行付手续费请通过随行付后台申请开票。
            </p>
          </div>
          <div class="pay-info-title">
            <span>开票信息</span>
          </div>
          <el-form-item label="发票类型" prop="invoiceType" :rules="[Validator.required()]">
            <el-radio-group v-model="codeForm.invoiceType">
              <el-radio :label="invoiceTypeMap.normal">增值税普通发票（电子）</el-radio>
              <el-radio :label="invoiceTypeMap.special">增值税专用发票（电子）</el-radio>
            </el-radio-group>
          </el-form-item>
          <template v-if="defautInvoiceData.invoiceTaxNo">
            <el-form-item label="使用默认开票信息" prop="invoiceDefault">
              <el-switch v-model="codeForm.invoiceDefault" @change="onDefaultInvoiceChange">
              </el-switch>
            </el-form-item>
          </template>
          <template v-else>
            <el-form-item label="使用默认开票信息" prop="invoiceDefault">
              <span style="color: #fe8604">您还未设置开票信息</span>
            </el-form-item>
          </template>
          <el-form-item label="发票抬头" prop="invoiceTitle" :rules="[Validator.required()]">
            <el-input
              v-model.trim="codeForm.invoiceTitle"
              class="input-width"
              auto-complete="off"
              size="small"
              maxlength="50"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item label="发票税号" prop="invoiceTaxNo" :rules="[Validator.required()]">
            <el-input
              v-model.trim="codeForm.invoiceTaxNo"
              class="input-width"
              auto-complete="off"
              size="small"
              placeholder="请输入"
              maxlength="50"
            ></el-input>
          </el-form-item>
          <el-form-item label="联系人姓名" prop="contactName" :rules="[Validator.required()]">
            <el-input
              v-model.trim="codeForm.contactName"
              class="input-width"
              auto-complete="off"
              size="small"
              placeholder="请输入"
              maxlength="20"
            ></el-input>
          </el-form-item>
          <el-form-item label="联系人电话" prop="contactPhone" :rules="[Validator.required()]">
            <el-input
              v-model.trim="codeForm.contactPhone"
              class="input-width"
              auto-complete="off"
              size="small"
              maxlength="20"
              placeholder="请输入"
            ></el-input>
          </el-form-item>

          <!-- 普通发票展示 -->
          <template v-if="codeForm.invoiceType === 1">
            <el-form-item
              label="交付邮箱"
              prop="submitAddress"
              :rules="[Validator.checkSubmitEmail()]"
            >
              <el-input
                v-model.trim="codeForm.submitAddress.deliveryMail"
                class="input-width"
                auto-complete="off"
                size="small"
                maxlength="50"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
          </template>
          <!-- 专用发票展示 -->
          <template v-if="codeForm.invoiceType === 2">
            <el-form-item
              label="交付邮箱"
              prop="submitAddress"
              :rules="[Validator.checkSubmitEmail()]"
            >
              <el-input
                v-model.trim="codeForm.submitAddress.deliveryMail"
                class="input-width"
                auto-complete="off"
                size="small"
                maxlength="50"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
            <el-form-item label="开户银行" prop="dospoistBank" :rules="[Validator.required()]">
              <el-input
                v-model.trim="codeForm.dospoistBank"
                class="input-width"
                auto-complete="off"
                size="small"
                maxlength="50"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
            <el-form-item label="开户账号" prop="dospoistAccount" :rules="[Validator.required()]">
              <el-input
                v-model.trim="codeForm.dospoistAccount"
                class="input-width"
                auto-complete="off"
                size="small"
                maxlength="50"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
            <el-form-item label="注册地址" prop="registerAddress" :rules="[Validator.required()]">
              <el-input
                v-model.trim="codeForm.registerAddress"
                class="input-width"
                auto-complete="off"
                size="small"
                maxlength="100"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
            <el-form-item label="注册电话" prop="registerPhone" :rules="[Validator.required()]">
              <el-input
                v-model.trim="codeForm.registerPhone"
                class="input-width"
                auto-complete="off"
                size="small"
                maxlength="20"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
          </template>
        </el-form>
        <div class="save-wrap">
          <el-button
            type="primary"
            v-preventReClick
            @click="codeSubmit"
            size="medium"
            :loading="submitLoading"
            >{{ invoiceId ? '重新提交' : '确认申请' }}
          </el-button>
        </div>
      </div>
    </main-layout>
    <UploadProtocol v-if="modalVisible" :visible.sync="modalVisible" @submit="upload" />
  </div>
</template>
<script>
import MainLayout from '@/views/layout/mainlayout';
import UploadProtocol from './uploadProtocol';
import { _dateFormat, countDateDistance } from '@/utils/times';

const invoiceDefaultRelatedFields = [
  'invoiceTitle',
  'invoiceTaxNo',
  'contactName',
  'contactPhone',
  'dospoistBank',
  'dospoistAccount',
  'registerAddress',
  'registerPhone',
  'submitAddress',
];
const specialInvoiceFields = [
  'dospoistBank',
  'dospoistAccount',
  'registerAddress',
  'registerPhone',
];
export default {
  name: 'ShopDetail',
  components: {
    MainLayout,
    UploadProtocol,
  },
  data() {
    return {
      registerType: '', // 用户类型
      loaded: false,
      codeForm: {
        tradeTimeRange: '',
        tradeTimeRangeTmp: undefined, // 用于临时保存时间
        invoiceTitle: '',
        invoiceTaxNo: '',
        contactName: '',
        contactPhone: '',
        dospoistBank: '',
        dospoistAccount: '',
        registerAddress: '',
        registerPhone: '',
        invoiceType: 1, // 注意 1 普通发票  2 专票
        invoiceDefault: false, // 使用默认开票信息
        fee: undefined, // 手续费金额
        deliveryMail: '',
        submitAddress: {
          deliveryMail: '',
        },
      },
      invoiceTypeMap: {
        normal: 1,
        special: 2,
      },
      checkAreement: -1, // -1:未查询。0 需要弹窗。1 不需要弹窗
      codeFormBackup: {}, //
      submitLoading: false,
      defautInvoiceData: {},
      modalVisible: false,
      pickerOptions: {
        disabledDate(time) {
          return (
            time.getTime() > new Date(new Date().getTime() - 24 * 60 * 60 * 1000) ||
            time.getTime() < new Date('2020-07-01 00:00')
          );
        },
      },
      invoiceId: '', // 开票申请id，如果有值则为编辑，没有则为新增
      detail: {},
    };
  },
  mounted() {
    this.getAuth();
    this.invoiceId = this.$route.query.id || '';
    if (this.invoiceId) {
      this.queryInvoiceDetail();
    } else {
      this.loaded = true;
    }
    this.queryDefaultInvoice();
  },
  methods: {
    // 上传协议
    upload() {
      this.checkAreement = 1;
      this.modalVisible = false;
    },
    getAuth() {
      const registerType = sessionStorage.getItem('registerType');
      this.registerType = registerType;
      const extOperation = sessionStorage.getItem('extOperation'); // 操作门店收款码
      if (registerType && registerType == '0') {
        extOperation ? '' : (this.extOperation = false);
      }
    },
    onTradeTimeChange() {
      if (this.codeForm.tradeTimeRangeTmp.length <= 0) {
        return;
      }
      this.checkAreement = -1;
      const beginTime = this.codeForm.tradeTimeRangeTmp[0];
      const endTime = this.codeForm.tradeTimeRangeTmp[1];
      const dateDistance = countDateDistance(endTime, beginTime);
      if (dateDistance >= 24 && dateDistance <= 366) {
        this.codeForm.tradeTimeRange = this.codeForm.tradeTimeRangeTmp;
        this.api
          .post('/juhe/serviceChargeInvoice/sumFee.do', {
            beginTime: _dateFormat(beginTime, 'yy-MM-dd'),
            endTime: _dateFormat(endTime, 'yy-MM-dd'),
          })
          .then(({ data, code }) => {
            if (code === 200) {
              this.codeForm.fee = data;
            }
          });
        this.checkMerchantAgreementPic();
      } else {
        this.codeForm.tradeTimeRangeTmp = this.codeForm.tradeTimeRange || undefined;
        this.$message.error('时间范围请选择25~366天之间');
      }
    },
    async checkMerchantAgreementPic() {
      const beginTime = this.codeForm.tradeTimeRangeTmp[0];
      const endTime = this.codeForm.tradeTimeRangeTmp[1];
      if (this.checkAreement === -1) {
        const { data, code } = await this.api.post(
          '/juhe/serviceChargeInvoice/checkMerchantAgreementPic.do',
          {
            beginTime: _dateFormat(beginTime, 'yy-MM-dd'),
            endTime: _dateFormat(endTime, 'yy-MM-dd'),
          },
        );
        if (code === 200) {
          this.checkAreement = Number(data);
          data || (this.modalVisible = true);
          return this.checkAreement;
        }
      } else {
        this.modalVisible = true;
        return this.checkAreement;
      }
    },
    queryInvoiceDetail() {
      this.api
        .post('/juhe/serviceChargeInvoice/queryInvoiceDetail.do', {
          id: String(this.invoiceId),
        })
        .then((res) => {
          if (res.code == 200) {
            this.detail = res.data;
            Object.keys(this.codeForm).forEach((key) => {
              this.codeForm[key] = this.detail[key];
            });
            this.codeForm.tradeTimeRangeTmp = this.codeForm.tradeTimeRange = [
              new Date(this.detail.transactionBeginTime),
              new Date(this.detail.transactionEndTime),
            ];
            this.codeForm.submitAddress = {
              deliveryMail: this.detail.deliveryMail || '',
            };
            this.codeForm.invoiceDefault = !!this.codeForm.invoiceDefault;

            console.log(this.codeForm, 'codeForm**');
          } else {
            this.$message.error(res.message);
          }
        })
        .finally(() => {
          this.loaded = true;
        });
    },
    queryDefaultInvoice() {
      this.api.post('/juhe/serviceChargeInvoice/queryDefaultInvoiceDetail.do').then((res) => {
        if (res.code === 200) {
          this.defautInvoiceData = res.data;
        }
      });
    },
    onDefaultInvoiceChange(useDefaultFlag) {
      let formTmp = {};
      if (useDefaultFlag) {
        invoiceDefaultRelatedFields.map((key) => {
          this.codeFormBackup[key] = this.codeForm[key];
        });
        formTmp = this.defautInvoiceData;
        formTmp.submitAddress = {
          deliveryMail: formTmp.deliveryMail,
        };
      } else {
        formTmp = this.codeFormBackup;
        formTmp.submitAddress = {
          deliveryMail: '',
        };
      }
      invoiceDefaultRelatedFields.forEach((key) => {
        this.codeForm[key] = formTmp[key];
      });
    },
    backInvoiceListPage() {
      this.$store.commit('delete_tabs_byname', '/applyInvoice');
      this.$router.push('/feeInvoice');
    },
    codeSubmit() {
      this.$refs.codeFormRef.validate(async (valid) => {
        if (valid) {
          // if (this.codeForm.fee < 100 && this.codeForm.invoiceType === 2) {
          //   this.$message.error('不足100元不可开票');
          //   return;
          // }
          const formData = { ...this.codeForm };
          formData.deliveryMail = formData.submitAddress.deliveryMail;
          delete formData.submitAddress;
          if (this.checkAreement !== 1) {
            const checkAreement = await this.checkMerchantAgreementPic();
            // 弹出上传窗口
            if (checkAreement !== 1) {
              return;
            }
          }
          if (this.codeForm.tradeTimeRange.length > 0) {
            formData.transactionBeginTime = _dateFormat(
              this.codeForm.tradeTimeRange[0],
              'yy-MM-dd',
            );
            formData.transactionEndTime = _dateFormat(this.codeForm.tradeTimeRange[1], 'yy-MM-dd');

            delete formData.tradeTimeRange;
            delete formData.tradeTimeRangeTmp;
          }
          formData.invoiceDefault = formData.invoiceDefault ? 1 : 0;
          if (this.codeForm.invoiceType === this.invoiceTypeMap.normal) {
            // 专票的几个字段要删除掉
            Object.keys(formData).forEach((key) => {
              if (specialInvoiceFields.indexOf(key) > -1) {
                formData[key] = undefined;
              }
            });
          }

          if (this.invoiceId) {
            formData.id = this.invoiceId;
          }
          formData.mailingAddress = '';
          formData.deliveryPhone = '';
          this.api
            .post(
              this.invoiceId
                ? '/juhe/serviceChargeInvoice/updateInvoice.do'
                : '/juhe/serviceChargeInvoice/createInvoice.do',
              formData,
            )
            .then(({ code, message }) => {
              console.log('####################');
              if (code === 200) {
                this.$message.success('提交成功');
                this.backInvoiceListPage();
              } else {
                this.$message.error(message);
              }
            });
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.set-invoice {
  padding: 28px 15px 40px 32px;
  .save-wrap {
    padding-left: 104px;
  }
}
.pay-info-title {
  height: 36px;
  line-height: 36px;
  background-color: #f5f7fa;
  font-size: 14px;
  padding: 0 16px;
  color: #303133;
  font-weight: bold;
  display: flex;
  justify-content: space-between;
  color: rgba(102, 102, 102, 1);
  margin-bottom: 20px;
  .extra {
    font-size: 12px;
    color: #1989fa;
    cursor: pointer;
  }
}
.pay-money-info {
  background: #f5f7fa;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  width: 410px;
  padding: 16px;
  margin-bottom: 18px;
  margin-left: 103px; // 左对齐
  .money {
    font-size: 20px;
    color: #333333;
    letter-spacing: 0;
    line-height: 20px;
    font-weight: bold;
    margin-left: 10px;
  }
  .error-tips {
    font-size: 14px;
    color: #ff3646;
    letter-spacing: 0;
    margin-left: 20px;
  }
  .tips {
    font-size: 12px;
    color: #606266;
    letter-spacing: 0;
    margin-top: 18px;
    .el-icon-warning {
      color: #f5a623;
    }
  }
}
</style>
<style lang="scss">
.set-invoice {
  .tree-select,
  .input-width,
  .el-date-editor {
    width: 314px;
  }
  .icon-tishi {
    margin-left: 5px;
    vertical-align: middle;
  }
  .hide {
    .el-upload--picture-card {
      display: none;
    }
  }
}
.inline-block-box {
  .el-form-item,
  .inline-block-box-item {
    display: inline-block;
  }
}
</style>
